//LIBRARIES
import React, { useState } from 'react';
import styled from 'styled-components';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

//ASSETS
import HowIsCalculated from 'assets/how_is_calculated.svg';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';

const StyledImg = styled.img`
  width: 100%;
  margin-bottom: 20px;
`;

const StyledExpandLess = styled(ExpandLess)`
  vertical-align: middle;
  margin-right: 10px;
`;

const StyledExpandMore = styled(ExpandMore)`
  vertical-align: middle;
  margin-right: 10px;
`;

const StyledTab = styled.div`
  font-size: 18px;
  font-weight: 900;
  line-height: 24px;
  cursor: pointer;
  margin: 15px 0;
`;

const OptionA = styled.div`
  margin: auto;
  width: 90%;
`;

const StyledDiv = styled.div`
  margin: 10px 0;
`;

const Header = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 10px;
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  margin-bottom: 20px;
`;

const BoldText = styled.b`
  font-weight: 900 !important;
`;

const ClosedIconDiv = styled.div`
  text-align: right;
  cursor: pointer;
`;

const INDIVIDUAL_LEASE_HOLDER = 'individual';
const MULTIPLE_LEASE_HOLDER = 'multiple';

const AutoPayExplaination = ({ isOpen, onClose, type }) => {
  const [individualState, setIndividualState] = useState(false);
  const [multipleState, setMultipleState] = useState(false);

  const handleClick = toggleName => {
    if (toggleName === INDIVIDUAL_LEASE_HOLDER) {
      setIndividualState(!individualState);
    } else if (toggleName === MULTIPLE_LEASE_HOLDER) {
      setMultipleState(!multipleState);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      isModal
      aria-labelledby="autopay-payment-explaination"
      classes={{
        paper: 'form-dialog',
      }}
    >
      <DialogTitle style={{ paddingBottom: '0px'}}>
        <ClosedIconDiv className="row">
          <CloseIcon onClick={onClose} />
        </ClosedIconDiv>
      </DialogTitle>
      <DialogContent>
        {
          type === 'optionA' ?
          <OptionA>
            <Header>{getTranslatedString('autopay.explaination.payInFullBalance')}</Header>
            <Description>{getTranslatedString('autopay.explaination.sampleDescription')}</Description>
            <div>
              <StyledTab onClick={() => handleClick(INDIVIDUAL_LEASE_HOLDER)}>
                {getTranslatedString('autopay.explaination.individualLeaseHolder')}
                {individualState ? <StyledExpandLess /> : <StyledExpandMore />}
              </StyledTab>
              {individualState && <IndividualLeaseDetail />}
              <StyledTab onClick={() => handleClick(MULTIPLE_LEASE_HOLDER)}>
                {getTranslatedString('autopay.explaination.multipleLeaseHolders')}
                {multipleState ? <StyledExpandLess /> : <StyledExpandMore />}
              </StyledTab>
              {multipleState && <MultipleLeaseDetail />}
            </div>
          </OptionA>
          :
          <OtherChargesDetail/>
        }
      </DialogContent>
    </Dialog>
  );
};

const OtherChargesDetail = () => (
  <div>
    <Header>{getTranslatedString('autopay.explaination.otherCharges')}</Header>
    <Description>{getTranslatedString('autopay.explaination.otherChargesDetail')}</Description>
  </div>
);

const IndividualLeaseDetail = () => (
  <div>
    <StyledDiv className="row">
      <div className="col-sm-6" style={{ padding: 0 }}>
        {getTranslatedString('autopay.explaination.fullBalanceExample', { balance: '$2,000' })}
      </div>
      <div className="col-sm-6" style={{ padding: 0 }}>
        {getTranslatedString('autopay.explaination.numberOfLeaseHolders', { numOfHolders: 1 })}
      </div>
    </StyledDiv>
    <BoldText>
      {getTranslatedString('autopay.explaination.youWouldPay', { amount: '$2,000' })}
    </BoldText>
  </div>
);

const MultipleLeaseDetail = () => (
  <div>
    <Description>{getTranslatedString('autopay.explaination.youPayFullBalance')}</Description>
    <StyledDiv className="row">
      <div className="col-sm-6" style={{ padding: 0 }}>
        {getTranslatedString('autopay.explaination.fullBalanceExample', { balance: '$2,000' })}
      </div>
      <div className="col-sm-6" style={{ padding: 0 }}>
        {getTranslatedString('autopay.explaination.numberOfLeaseHolders', { numOfHolders: 4 })}
      </div>
    </StyledDiv>
    <StyledDiv>
      <BoldText>{getTranslatedString('autopay.explaination.resident', { id: 1 })}</BoldText>
      {getTranslatedString('autopay.explaination.payingSpecifedAmount', { amount: '$500.00' })}
    </StyledDiv>
    <StyledDiv>
      <BoldText>{getTranslatedString('autopay.explaination.resident', { id: 2 })}</BoldText>
      {getTranslatedString('autopay.explaination.payingSpecifedAmount', { amount: '$400.00' })}
    </StyledDiv>
    <StyledDiv>
      <BoldText>{getTranslatedString('autopay.explaination.resident', { id: 3 })}</BoldText>
      {getTranslatedString('autopay.explaination.payingFullBalance')}
    </StyledDiv>
    <StyledDiv>
      <BoldText>{getTranslatedString('autopay.explaination.you')}</BoldText>
      {getTranslatedString('autopay.explaination.payingFullBalance')}
    </StyledDiv>
    <StyledImg src={HowIsCalculated} alt="How it's calculated" />
  </div>
);

export default AutoPayExplaination;
